import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CustomKeycloakService } from '../keycloak.service';
import { UserService } from '../user.service';
import { environment } from '../../../environments/environment';

export const guestGuard: CanActivateFn = () => {
  if (environment.isTesting) return true;
  const userService = inject(UserService);
  const keycloakService = inject(CustomKeycloakService);
  const router = inject(Router);

  try {
    if (keycloakService.isStoredTokenValid()) {
      return router.createUrlTree(['/']);
    }

    if (keycloakService.isSSOAuthenticated()) {
      return router.createUrlTree(['/']);
    }

    if (keycloakService.isAuthenticated()) {
      return router.createUrlTree(['/']);
    }
  } catch (error) {
    console.warn(
      'Error checking Keycloak authentication in guest guard:',
      error
    );
  }

  const legacyToken =
    userService.currentAccessToken || localStorage.getItem('access_token');

  if (legacyToken) {
    return router.createUrlTree(['/']);
  }

  return true;
};
